import { render, staticRenderFns } from "./Women.vue?vue&type=template&id=5fe3d15b"
import script from "./Women.vue?vue&type=script&lang=js"
export * from "./Women.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports